import { z } from 'zod';

const NonNegativeCentsStringSchema = z
  .string()
  .regex(/^\d+$/, 'must be a non-negative integer string (cents)');

/** GET /service-orders/organization-period-summary — BR-SO-212 */
export const GetOrganizationPeriodSummaryQuerySchema = z.object({
  from: z.iso.date(),
  to: z.iso.date(),
});
export type GetOrganizationPeriodSummaryQuery = z.infer<
  typeof GetOrganizationPeriodSummaryQuerySchema
>;

export const GetOrganizationPeriodSummaryResponseSchema = z.object({
  finishedCount: z.number().int().nonnegative(),
  averageTicketCents: NonNegativeCentsStringSchema,
  quoteConversionPercent: z.number().nonnegative(),
  /** Quotes with civil `created_at` in [from, to] — denominator of `quoteConversionPercent` (BR-SO-212). */
  openedQuoteCount: z.number().int().nonnegative(),
});
export type GetOrganizationPeriodSummaryResponse = z.infer<
  typeof GetOrganizationPeriodSummaryResponseSchema
>;
